/* eslint-disable no-console */
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';
import { BodyOverlay } from '../BodyOverlay/BodyOverlay';

@Component
export class WindspeedPopup extends ThemeComponent {
    @Ref windspeedPopup!: HTMLElement;
    @Ref closeButton!: HTMLButtonElement;

    private bodyOverlay: BodyOverlay|null = document.querySelector('.body-overlay');

    init() {
        document.addEventListener('bodyOverlayLoaded', () => this.bodyOverlayLoaded());

        document.addEventListener('openWindspeedPopup', (e) => {
            if (this.windspeedPopup) {
                this.open();
            }
        });

        this.$listen(this.closeButton, 'click', (e) => {
            if (this.windspeedPopup) {
                this.close();
            }
        });
    }

    bodyOverlayLoaded() {
        this.bodyOverlay = document.querySelector('.body-overlay') as BodyOverlay;

        if (this.bodyOverlay) {
            this.$subscribe(this.bodyOverlay.onCloseChange, () => {
                this.close();
            });
        }
    }

    /** Popup open */
    public open() {

        this.bodyOverlay = document.querySelector('.body-overlay');

        this.bodyOverlay?.openOverlay();

        document.body.classList.add('prevent-scroll');
        document.querySelector('.header')?.classList.add('cover-header');
        this.windspeedPopup.setAttribute('open', '');
        this.windspeedPopup.setAttribute('aria-hidden', 'false');
    }

    /** Popup close */
    public close() {
        this.bodyOverlay = document.querySelector('.body-overlay');

        this.bodyOverlay?.closeOverlay();

        document.body.classList.remove('prevent-scroll');
        document.querySelector('.header')?.classList.remove('cover-header');
        this.windspeedPopup.removeAttribute('open');
        this.windspeedPopup.setAttribute('aria-hidden', 'true');

    }
}
